import { render, staticRenderFns } from "./Playground.vue?vue&type=template&id=05438c59&scoped=true&"
import script from "./Playground.vue?vue&type=script&lang=js&"
export * from "./Playground.vue?vue&type=script&lang=js&"
import style0 from "./Playground.vue?vue&type=style&index=0&id=05438c59&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05438c59",
  null
  
)

export default component.exports